export const axisGridColor = '#FFFFFF50';

export const ticksColor = '#FFFFFF50';
